import React from 'react';
import { Link } from '@mui/material';
import {
	GridRowId,
	gridDetailPanelExpandedRowIdsSelector,
	useGridApiContext,
	useGridSelector,
} from '@mui/x-data-grid-premium';
import { useGlobalization } from '@Translations/useGlobalization';
import { RESULTS_LINK_COLOR } from '@Components/RiskDetails/linkColor';

interface Props {
	id: GridRowId;
}

// Text link that expands/collapses a row's Explanation panel (I360A-2744),
// replacing MUI's default +/− toggle in the redesigned grid.
export const DetailToggleCell = ({ id }: Props) => {
	const { t } = useGlobalization();
	const apiRef = useGridApiContext();
	const expandedIds = useGridSelector(
		apiRef,
		gridDetailPanelExpandedRowIdsSelector,
	);
	const isExpanded = expandedIds.includes(id);

	return (
		<Link
			component="button"
			underline="hover"
			data-cy="explanation-toggle"
			aria-expanded={isExpanded}
			onClick={event => {
				event.stopPropagation();
				apiRef.current.toggleDetailPanel(id);
			}}
			sx={{
				cursor: 'pointer',
				fontSize: '0.875rem',
				color: RESULTS_LINK_COLOR,
				fontFamily: 'inherit',
				display: 'inline-flex',
				alignItems: 'center',
				gap: 0.5,
			}}>
			{isExpanded ? t('Hide explanation') : t('Show explanation')}
			<span aria-hidden>{isExpanded ? '▲' : '▾'}</span>
		</Link>
	);
};

export default DetailToggleCell;
